<template>
  <div id="dashboard" class="correct-margin-right">
      <div class="column column-25">
        <div class="box shadow">
          <h2>{{ $t('calendar') }}</h2>

          <transition name="fade">
            <div class="content" v-if="appointments.loaded && appointments.error === null">
                <div class="calendar-wrapper">
                <div class="daypicker">
                  <span class="btn-previous" v-on:click="previousDay()">
                    <i class="fa fa-arrow-left"></i>
                  </span>

                  <span class="current-day">
                    {{ calendarSettings.viewDate | moment('D MMMM') }}
                  </span>

                  <span class="btn-next" v-on:click="nextDay()">
                    <i class="fa fa-arrow-right"></i>
                  </span>
                </div>

                <Calendar style="height: 650px;"
                          ref="calendar"
                          :view="calendarSettings.view"
                          :template="calendarSettings.template"
                          :taskView="calendarSettings.taskView"
                          :theme="calendarSettings.themeConfig"
                          :schedules="calendarSettings.scheduleList"/>
              </div>

              <div class="to-link">
                <a href="#">
                  {{ $t('view-agenda') }} <i class="fa fa-arrow-right"></i>
                </a>
              </div>

            </div>
          </transition>

          <div class="loader" v-if="!appointments.loaded"></div>
        </div>
      </div><!--
      --><div class="column column-75">
        <div class="column column-100" v-if="false">
          <div class="box shadow">
            <h2>{{ $t('unplanned') }}</h2>

            <!-- <div class="loader"></div> -->
          </div>
        </div>

        <div class="column column-50">
          <div class="box shadow" ref="tasks">
            <h2>{{ $t('tasks') }}</h2>

            <transition name="fade">
              <div class="content" v-show="tasks.loaded && tasks.data.length > 0 && tasks.error === null">
                <div class="tasks">
                    <task v-for="task in tasks.data"
                            :title="task.title"
                            :client="task.client"
                            :needsAttention="appointments.needs_attention"
                            :key="task._id"></task>
                </div>

                <div class="to-link">
                  <a href="#">
                    {{ $t('view-entity', { entity: $t('tasks') }) }} <i class="fa fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </transition>

            <div class="none-found" v-if="tasks.loaded && tasks.error === null && tasks.data.length === 0">
              {{ $t('all-tasks-done') }}, {{ taskEnthousiastic }}!
            </div>

            <div class="errors" v-if="tasks.loaded && tasks.error != null">
              {{ $t('error-loading-entity', { entity: $t('tasks').toLowerCase() }) }}
            </div>

            <div v-if="!tasks.loaded" class="loader"></div>
          </div>
        </div><!--
        --><div class="column column-50">
          <div class="box shadow">
            <h2>{{ $t('tickets') }}</h2>

            <transition name="fade">
              <div class="content" v-show="tickets.loaded && tickets.error === null && tickets.data.length > 0">
                <div class="tickets">

                  <ticket v-for="ticket in tickets.data"
                          :id="ticket._id"
                          :title="ticket.title | truncate(50)"
                          :client="ticket.client.name | truncate(50)"
                          :key="ticket._id"></ticket>

                </div>
                <div class="to-link">
                  <router-link to="/tickets">
                    {{ $t('view-entity', { entity: $t('tickets') }) }} <i class="fa fa-arrow-right"></i>
                  </router-link>
                </div>
              </div>
            </transition>

            <div class="none-found" v-if="tickets.loaded && tickets.error === null && tickets.data.length === 0">
              {{ $t('all-tickets-done') }}, {{ ticketsEnthousiastic }}!
            </div>

            <div class="errors" v-if="tickets.loaded && tickets.error != null">
              {{ $t('error-loading-entity', { entity: $t('appointments').toLowerCase() }) }}
            </div>

            <div v-if="!tickets.loaded" class="loader"></div>
          </div>
        </div>

        <div class="column column-50">
          <div class="box shadow">
            <h2>{{ $t('appointments') }}</h2>

            <transition name="fade">
              <div class="content" v-show="appointments.loaded && appointments.error === null && appointments.data.length > 0">
                <div class="appointments">
                    <appointment v-for="appointment in appointments.data"
                            :title="appointment.title"
                            :start="appointment.start"
                            :end="appointment.end"
                            :client="appointment.company.name || appointment.contact.fullName"
                            :key="appointment._id"></appointment>
                </div>

                <div class="to-link">
                  <a href="#">
                    {{ $t('view-entity', { entity: $t('appointments') }) }} <i class="fa fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </transition>

            <div class="none-found" v-if="appointments.loaded && appointments.error === null && appointments.data.length === 0">
              {{ $t('no-appointments') }}.
            </div>

            <div class="errors" v-if="appointments.loaded && appointments.error != null">
              {{ $t('error-loading-entity', { entity: $t('appointments').toLowerCase() }) }}
            </div>

            <div v-if="!appointments.loaded" class="loader"></div>
          </div>
        </div><!--
          --><div class="column column-50">
          <div class="box shadow" ref="deals">
            <h2>{{ $t('deals') }}</h2>

            <transition name="fade">
              <div class="content" v-show="deals.loaded && deals.error === null && deals.data.length > 0">
                <div class="deals">
                  <div class="deals-wrapper">
                    <deal v-for="deal in deals.data"
                          :title="deal.title"
                          :client="deal.client"
                          :last_action="deal.updated_at"
                          :stage="deal.stage"
                          :percentage="(100 * deal.stage.index) / deals.totalStages"
                          :needsAttention="appointments.needs_attention"
                          :key="deal._id"></deal>
                  </div>
                </div>

                <div class="to-link">
                  <a href="#">
                    {{ $t('view-entity', { entity: $t('deals') }) }} <i class="fa fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </transition>

            <div class="none-found" v-if="deals.loaded && deals.error === null && deals.data.length === 0">
              {{ $t('no-deals') }}.
            </div>


            <div class="errors" v-if="deals.loaded && deals.error != null">
              {{ $t('error-loading-entity', { entity: $t('deals').toLowerCase() }) }}
            </div>

            <div v-if="!deals.loaded" class="loader"></div>
          </div>
        </div>

    </div>

    <talking-bird v-if="query.login"
                  :text="`${birdGreeting} ${user.firstName}!
                  Je hebt vandaag 2 afspraken en 1 deal die je aandacht nodig hebben!`">

    </talking-bird>
  </div>
</template>

<script>
import 'tui-calendar/dist/tui-calendar.css';
import { Calendar } from '@toast-ui/vue-calendar';
import { Tasks, Deals, Tickets, Appointments, Schedule } from '../services/api/ApiRoutes';

export default {
  name: 'Dashboard',
  data() {
    const formattedDate = this.$t('date-today', { date: this.$moment().format(this.$t('date-today-format')) });
    const $moment = this.$moment;
    const $t = this.$t;
    const user = this.$parent.user;
    const allDayTitle = this.$t('all-day');

    // Set page title
    this.$parent.title.heading = `${this.$parent.getGreeting()}, ${user.firstName}!`;
    this.$parent.title.subheading = this.$parent.formattedDate;

    return {
      formattedDate,
      user,
      query: this.$route.query,
      tasks: {
        loaded: false,
        data: [],
        error: null,
      },
      deals: {
        loaded: false,
        data: [],
        error: null,
        totalStages: 0,
      },
      appointments: {
        loaded: false,
        data: [],
        error: null,
      },
      tickets: {
        loaded: false,
        data: [],
        error: null,
      },
      calendar: {
        loaded: false,
        data: [],
        error: null,
      },
      birdGreeting: this.$parent.pickRandom(this.$t('informal-greeting')),
      calendarSettings: {
        viewDate: this.$moment(),
        view: 'day',
        taskView: false,
        themeConfig: {
        },
        template: {
          alldayTitle() {
            return `<span class="tui-full-calendar-left-content">Hele dag</span>`; // TODO translate
          },
          weekDayname(model) {
            return `<span class="tui-full-calendar-dayname-date">${$moment(model.renderDate).format('dddd DD MMMM')}</span>`;
          },
          timegridDisplayPrimaryTime(time) {
            return `${time.hour}:00`;
          },
          popupSave() {
            return 'Opslaan'; // TODO translate
          },
          popupEdit() {
            return 'Aanpassen';
          },
          popupDelete() {
            return 'Verwijderen';
          },
          popupDetailDate: function(isAllDay, start, end) {
            let isSameDate = $moment(start._date).isSame(end._date, 'day');
            let endFormat = (isSameDate ? '' : 'DD-MM-YYYY ') + 'H:mm';

            if (isAllDay) {
              return $moment(start._date).format('DD-MM-YYYY') + (isSameDate ? '' : ' - ' + $moment(end._date).format('DD-MM-YYYY'));
            }

            return ($moment(start._date).format('DD-MM-YYYY H:mm') + ' - ' + $moment(end._date).format(endFormat));
          },
        },
        scheduleList: [
          {
            id: '1',
            calendarId: '1',
            title: '16:00 - Afspraak met Frats',
            category: 'time',
            dueDateClass: '',
            start: 'Mon Mar 11 2019 16:00:00 GMT+0100',
            end: 'Mon Mar 11 2019 17:00:00 GMT+0100',
          },
          {
            id: '2',
            calendarId: '1',
            title: '16:30 - Afspraak met Frats',
            category: 'time',
            dueDateClass: '',
            start: 'Mon Mar 11 2019 16:30:00 GMT+0100',
            end: 'Mon Mar 11 2019 17:30:00 GMT+0100',
          },
          {
            id: '3',
            calendarId: '1',
            title: '17:30 - Borrelen met Nolan',
            category: 'time',
            dueDateClass: '',
            start: 'Mon Mar 11 2019 17:30:00 GMT+0100',
            end: 'Mon Mar 11 2019 20:30:00 GMT+0100',
          },
        ],
      },
    };
  },

  mounted() {
    this.getTasks();
    this.getDeals();
    this.getAppointments();
    this.getTickets();
    this.getSchedule();
  },

  methods: {
    testFunction() {
      console.log("joejoe");
    },

    previousDay() {
      this.$refs.calendar.invoke('prev');
      this.calendarSettings.viewDate.subtract(1, 'days');

      this.$forceUpdate();
    },

    nextDay() {
      this.$refs.calendar.invoke('next');
      this.calendarSettings.viewDate.add(1, 'days');

      this.$forceUpdate();
    },

    getTasks() {
      Tasks.get({ _limit: 5 }).then((tasks) => {
        this.tasks.error = null;
        this.tasks.data = tasks;
        this.tasks.loaded = true;
      }).catch((error) => {
        this.tasks.error = error;
        this.tasks.loaded = true;
      });
    },

    getDeals() {
      let returnDeals = [];

      Deals.get({ _limit: 5 }).then((deals) => {
        returnDeals = deals;
        return Deals.getDealStages();
      }).then((dealStages) => {
        this.deals.totalStages = dealStages.length + 1;
        this.deals.error = null;
        this.deals.data = returnDeals;
        this.deals.loaded = true;
      }).catch((error) => {
        this.deals.error = error;
        this.deals.loaded = true;
      });
    },

    getAppointments() {
      Appointments.get({ _limit: 5, _sort: 'start', _order: 'desc' }).then((appointments) => {
        this.appointments.error = null;
        this.appointments.data = appointments;
        this.appointments.loaded = true;
      }).catch((error) => {
        this.appointments.error = error;
        this.appointments.loaded = true;
      });
    },

    getTickets() {
      Tickets.get({ _limit: 5 }).then((tickets) => {
        this.tickets.error = null;
        this.tickets.data = tickets;
        this.tickets.loaded = true;
      }).catch((error) => {
        this.tickets.error = error;
        this.tickets.loaded = true;
      });
    },

    getSchedule() {
      Schedule.get().then((calendar) => {
        this.calendarSettings.scheduleList = calendar.map((event) => {
          let eventStart = this.$moment(event.start);

          event.calendarId = 1;
          event.id = event._id;
          event.title = eventStart.format('HH') + ":" + eventStart.format('mm') + " - " + event.title;
          event.category = 'time';
          event.body = event.description;
          event.attendees = [event.contact.fullName || event.company.name, event.user.fullName];
          event.location = this.$t('address-short', {
            street: event.location.value.street,
            number: event.location.value.number,
            zipcode: event.location.value.zipcode,
            city: event.location.value.city,
          });

          return event;
        });

        this.calendar.error = null;
        this.calendar.data = calendar;
        this.calendar.loaded = true;
      }).catch((error) => {
        this.calendar.error = error;
        this.calendar.loaded = true;
      });
    },
  },

  computed: {
    taskEnthousiastic() {
      return this.$parent.pickRandom(this.$t('enthousiastic'));
    },

    ticketsEnthousiastic() {
      return this.$parent.pickRandom(this.$t('enthousiastic'));
    },
  },

  components: {
    Calendar,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .daypicker {
    text-align: center;
    color: #3D70FF;
    color: var(--primary-color);
    font-weight: 600;
    font-size: 1.3em;
    height: 50px;
  }

  .daypicker .btn-previous,
  .daypicker .btn-next {
    font-weight: bolder;
    cursor: pointer;
  }

  .daypicker .btn-previous {
    float: left;
  }

  .daypicker .btn-next {
    float: right;
  }

  .deals {
    width: 100%;
    overflow-x: scroll;
  }

  .deals-wrapper {
    width: 1200px;
  }

  .deal {
    background: white;
    display: inline-block;
    padding: 10px;
    margin: 10px;
    width: 200px;
    vertical-align: top;
    transition: all .2s ease;
  }

  .deal >>> .title {
    color: #3D70FF;
    color: var(--primary-color);
    font-size: 1.2em;
    font-weight: 600;
  }

  .deal >>> .client {
    font-style: italic;
    font-weight: 300;
  }

  .deal >>> .last_action {
    margin-top: 20px;
  }

  .deal >>> .stage-progress {
    height: 10px;
    border-radius: 100px;
    background: rgba(0,0,0, .1);
    transition: width 2s ease;
  }

  .deal >>> .progress-fill {
    border-radius: 100px;
    height: 100%;
    background: #3D70FF;
    background: var(--primary-color);
  }

  .appointment >>> .date {
    color: #3D70FF;
    color: var(--primary-color);
    padding: 3px;
    border-radius: 5px;
    float: right;
    font-size: .8em;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue